import { createRoot } from 'react-dom/client';

import '@/common/env';
import { App } from '@/components/App';

import './polyfills';

const root = createRoot(document.getElementById('ReactAppRoot')!);
root.render(<App />);
